var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYogaArmStretch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39355 12.4709C1.39355 13.1671 1.67012 13.8348 2.1624 14.3271C2.65468 14.8194 3.32236 15.0959 4.01855 15.0959C4.71475 15.0959 5.38243 14.8194 5.87471 14.3271C6.36699 13.8348 6.64355 13.1671 6.64355 12.4709C6.64355 11.7747 6.36699 11.107 5.87471 10.6148C5.38243 10.1225 4.71475 9.84592 4.01855 9.84592C3.32236 9.84592 2.65468 10.1225 2.1624 10.6148C1.67012 11.107 1.39355 11.7747 1.39355 12.4709V12.4709Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7976 21.6939L19.2976 9.69391C19.1904 9.4078 18.9985 9.16122 18.7474 8.98716C18.4963 8.8131 18.1981 8.71986 17.8926 8.71991H10.3936V2.71991C10.3936 2.32208 10.2355 1.94055 9.95422 1.65925C9.67291 1.37794 9.29138 1.21991 8.89355 1.21991C8.49573 1.21991 8.1142 1.37794 7.83289 1.65925C7.55159 1.94055 7.39355 2.32208 7.39355 2.71991V22.2199C7.39355 22.6177 7.55159 22.9993 7.83289 23.2806C8.1142 23.5619 8.49573 23.7199 8.89355 23.7199C9.29138 23.7199 9.67291 23.5619 9.95422 23.2806C10.2355 22.9993 10.3936 22.6177 10.3936 22.2199V14.7199H14.9166L12.7166 21.7739C12.6497 21.964 12.6218 22.1656 12.6346 22.3667C12.6474 22.5678 12.7005 22.7642 12.7909 22.9443C12.8813 23.1244 13.007 23.2845 13.1606 23.4149C13.3142 23.5454 13.4924 23.6435 13.6848 23.7035C13.8771 23.7635 14.0796 23.7842 14.2801 23.7642C14.4806 23.7443 14.6751 23.6841 14.8518 23.5874C15.0286 23.4906 15.184 23.3593 15.3089 23.2011C15.4337 23.043 15.5255 22.8613 15.5786 22.6669L18.0266 14.8359L20.9926 22.7479C21.1325 23.1204 21.4146 23.4221 21.7769 23.5865C22.1392 23.751 22.5521 23.7648 22.9246 23.6249C23.2971 23.485 23.5987 23.2029 23.7632 22.8405C23.9277 22.4782 23.9415 22.0654 23.8016 21.6929L23.7976 21.6939Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.643555 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaArmStretch);
export default __webpack_public_path__ + "static/media/yoga-arm-stretch.bf1181ff3760b80404bed3cd5d31ed3d.svg";
export { ForwardRef as ReactComponent };